// extracted by mini-css-extract-plugin
export default {"errorBoundary":"ErrorBoundary_errorBoundary__xmn19","reload":"ErrorBoundary_reload__dnvNV","head":"ErrorBoundary_head__B0CW2","error":"ErrorBoundary_error__XcEKf"};